import { ErrorResponse, ServerError } from '~/infra/error-response/ErrorResponse';
import { TemplateErrorResponse } from '~/infra/error-response/TemplateErrorResponse';
export const isDuplicateNameError = (error)=>new ErrorResponse(error).hasServerError(ServerError.CustomPageTemplateDuplicateName);
export const extractExistingTemplateId = (error)=>{
    const errorResponse = new ErrorResponse(error);
    if (!errorResponse.hasServerError(ServerError.CustomPageTemplateDuplicateName)) return undefined;
    return new TemplateErrorResponse(errorResponse).existingTemplateId();
};
